module.exports = __webpack_public_path__ + "media/images/interstitial/promote-b70ebd08b33686eb6e20e0fa56797ad8.svg";